import { HttpRequest } from '@angular/common/http';

const PUBLIC_URLS: Set<string> = new Set([
  '/user/login',
  '/checkForgotPasswordMail/',
  '/resetForgotPassword/',
  '/userDataFromResetToken/',
]);
export class RequestClassifier {
  constructor(private readonly _request: HttpRequest<unknown>) {}

  public hasCaptcha(): boolean {
    return !!this._request.headers.get('captcha');
  }

  public isForLogin(): boolean {
    return this._request.url.includes('/user/login');
  }

  public isForPublicUrl(): boolean {
    return (
      PUBLIC_URLS.has(this._request.url) ||
      Array.from(PUBLIC_URLS).some((url) => this._request.url.includes(url))
    );
  }
}
